import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';

const Login = () => {
  const [formData, setFormData] = useState({
    username_or_email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowError(false);
    setError('');
    setLoading(true);

    try {
      const response = await authAPI.login(formData);
      localStorage.setItem('token', response.data.access_token);
      window.dispatchEvent(new Event('login'));
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
      setShowError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-logo">
        <img src="/assets/group-logo.png" alt="SortaFriends" className="logo-image" />
      </div>
      <h1 className="login-title">SortaFriends</h1>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username_or_email">Username or Email</label>
          <input
            type="text"
            id="username_or_email"
            name="username_or_email"
            value={formData.username_or_email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        {showError && error && (
          <div style={{ color: 'red', marginBottom: '15px' }}>
            {error}
          </div>
        )}
        <button 
          type="submit" 
          className="btn btn-primary" 
          style={{ width: '100%' }}
          disabled={loading}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      <div className="login-links">
        <Link to="/reset-password">Forgot username or password?</Link>
        <br />
        <Link to="/register">Create an account</Link>
        <br />
        <a 
          href="/terms-of-service" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: 'var(--color-text-muted)', textDecoration: 'none' }}
        >
          Terms of Service
        </a>
        <br />
        <div style={{ margin: '10px 0', borderTop: '1px solid var(--color-border)', paddingTop: '10px' }}>
          <a 
            href="/blog" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: 'var(--color-text-muted)', textDecoration: 'none' }}
          >
            Dev Blog
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login; 